import React from 'react';
import { Forgot as ForgotComponent } from '~/components/Auth/Forgot';

export function Forgot() {
    return (
        <div className="container">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <ForgotComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
